import { c as _c } from "react/compiler-runtime";
import type { IconProps } from '../types';
import { getIconColor } from '../utils/get-icon-color';
const IcoSidebarLeftOpen16 = t0 => {
  const $ = _c(8);
  const {
    "aria-label": ariaLabel,
    className,
    color
  } = t0;
  let t1;
  if ($[0] !== color) {
    t1 = getIconColor(color);
    $[0] = color;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const iconColor = t1;
  let t2;
  if ($[2] !== iconColor) {
    t2 = <path d="M12.8286 0.874756C14.0962 0.874756 15.1243 1.9022 15.1245 3.16968V12.8279C15.1245 14.0956 14.0963 15.1238 12.8286 15.1238H3.17041C1.90293 15.1236 0.875488 14.0954 0.875488 12.8279V3.16968C0.875682 1.90231 1.90305 0.874949 3.17041 0.874756H12.8286ZM6.23975 13.6238H12.8286C13.2679 13.6238 13.6245 13.2671 13.6245 12.8279V3.16968C13.6243 2.73061 13.2677 2.37476 12.8286 2.37476H6.23975V13.6238ZM3.17041 2.37476C2.73147 2.37495 2.37568 2.73074 2.37549 3.16968V12.8279C2.37549 13.267 2.73135 13.6236 3.17041 13.6238H4.73975V2.37476H3.17041Z" fill={iconColor} />;
    $[2] = iconColor;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== ariaLabel || $[5] !== className || $[6] !== t2) {
    t3 = <svg width={16} height={16} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" aria-label={ariaLabel} className={className} role="img" data-colored={false}>{t2}</svg>;
    $[4] = ariaLabel;
    $[5] = className;
    $[6] = t2;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  return t3;
};
export default IcoSidebarLeftOpen16;